import { Component, OnInit, Input} from '@angular/core';
import { SettingsService } from 'src/app/settings.service';
import { ApiService } from 'src/app/api.service';
import { ThemingService } from 'src/app/theming.service';
import { LambdaService } from 'src/app/lambda.service';
declare let $: any;

@Component({
  selector: 'app-collections',
  templateUrl: './collections.component.html',
  styleUrls: ['./collections.component.scss']
})

export class CollectionsComponent implements OnInit {
  @Input() collectionId: string = '';

collections: any[] = []
searchString: string = '';
loading: boolean = false;
modalDelete = false;
collectionIdToDelete: any;


constructor(
  private settingsService: SettingsService,
  private apiService: ApiService,
  private themingService: ThemingService,
  private lambdaService: LambdaService
) { }

ngOnInit(): void {
  this.getCollections()
}

async getCollections(): Promise<void> {
  try {
    const response: any = await this.lambdaService.getCollections(this.themingService.shopId);
    this.collections = Array.isArray(response.collections) ? response.collections : [];
  } catch (error) {
    console.error('Error fetching collections:', error);
    this.collections = [];
  }
}

  setCreatingCollection(){
    this.settingsService.setCreatingCollection();
  }

  setEditingCollection(collectionId: string){
  this.settingsService.setEditingCollection(collectionId);
  }

  searchCollections(){
  }

  deteleCollection(response: number) {
    if (response) {
      this.loading = true;
      this.lambdaService.deleteCollection(this.themingService.shopId, this.collectionIdToDelete)
        .then((data) => {
          this.getCollections();
          $('#deleteCollectionModal').modal('show');
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    }
    this.modalDelete = false;
  }

  closeModal(){
    $('#deleteCollectionModal').modal('hide');
  }
}
